import React, { useEffect } from "react";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import InputAHSF from "../../../Components/InputAHSF";
import { useDispatch, useSelector } from "react-redux";
import { GetApplicationInfo } from "../../../Redux/Reducers/Manager/ApplicationInformation";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import { useNavigate } from "react-router-dom";
import { encryptToken } from "../../../Services/Encryption/EncryptionParams";
import TextAreaAHSF from "../../../Components/TextAreaAHSF";
import { GetReportInfo } from "../../../Redux/Reducers/ReportStage/Report";

function AppInfo(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
    const UpdateBudgetItems = useSelector(
    (state) => state.BudgetItems.UpdateBudgetItems
  );
   const AddBudgetItems = useSelector(
    (state) => state.BudgetItems.AddBudgetItems
  );
    const loadingDeleteBudgetItems = useSelector(
    (state) => state.BudgetItems.loadingDeleteBudgetItems
  );
  const state = useSelector((state) => {
    return {
      ReportInfo: state.ReportStatus.ReportInfo,
    };
  });

  console.log(state?.ReportInfo?.applicationInformationId
, "ffffffff");

  useEffect(() => {
    dispatch(GetReportInfo({ reportId: props.reportId }));
  }, [props.reportId,loadingDeleteBudgetItems,UpdateBudgetItems,AddBudgetItems]);

  return (
    <>
    
      <SharedDiv
        showTitle={true}
        titleName="معلومات الطلب"
        child={[
          <div className="form-grid" key="info-grid">
            <InputAHSF
              fieldsName="ApplicationNumberInput"
              show={true}
              disabled={true}
              value={state.ReportInfo?.applicationNumber}
            />
            <InputAHSF
              fieldsName="FullNameOfResearcher"
              show={true}
              disabled={true}
              value={state.ReportInfo?.fullName}
            />
            <InputAHSF
              fieldsName="projectName"
              show={true}
              disabled={true}
              value={state.ReportInfo?.researchProjectTitleInArabic}
            />
            <InputAHSF
              fieldsName="FieldReport"
              show={true}
              disabled={true}
              value={state.ReportInfo?.field}
            />
            <InputAHSF
              fieldsName="NameOfFoundationReport"
              show={true}
              disabled={true}
              value={state.ReportInfo?.foundationName}
            />
            <InputAHSF
              fieldsName="ProjectDuration"
              show={true}
              disabled={true}
              value={state.ReportInfo?.projectDuration}
            />
            <InputAHSF
              fieldsName="RemainingProjectDuration"
              show={true}
              disabled={true}
              value={state.ReportInfo?.remainingDurationOfProject}
            />
            <InputAHSF
              fieldsName="TotalBudget"
              show={true}
              disabled={true}
              value={state.ReportInfo?.totalBudget}
              comma={true}
            />
            <InputAHSF
              fieldsName="RemainingBudget"
              show={true}
              comma={true}
              disabled={true}
              value={state.ReportInfo?.remainingBudget}
            />
          </div>,
        ]}
        showButton={true}
        id_Title="withBtnTitle"
        // buttonComponent={
        //   // Display a button to show the budget summary
        //   <ButtonAHSF
        //     id={"btnTitle"}
        //     type={"submitter"}
        //     onClick={() => {
        //       let token = encryptToken(props.applicationGuid);
        //       window.open(
        //         `/SRFund/manager/MainResearcherInformainContainer/` + token,
        //         "_blank"
        //       );
        //     }}
        //     disabled={false}
        //     title={"عرض الطلب"}
        //     text={"عرض الطلب"}
        //     show={true}
        //   />
        // }
        buttonComponent={
          window.location.href.includes("report") ||
          window.location.href.includes("manager") ? (
            <ButtonAHSF
              id={"btnTitle"}
              type={"submitter"}
              onClick={() => {
                let token = encryptToken(state?.ReportInfo?.applicationInformationId);
                window.open(
                  `/SRFund/manager/MainResearcherInformainContainer/` + token,
                  "_blank"
                );
              }}
              disabled={false}
              title={"عرض الطلب"}
              text={"عرض الطلب"}
              show={true}
            />
          ) : null
        }
      />
    </>
  );
}

export default AppInfo;
